export default "__VITE_ASSET__BCd0m7ic__"